import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import ChatWidget from "../components/site/ChatWidget";
import { SERVICES } from "../lib/api";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight, Check } from "lucide-react";

export default function Services() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="pt-32 pb-16 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-[11px] uppercase tracking-[0.22em] text-primary mb-3">Services</div>
        <h1 className="font-display text-5xl lg:text-6xl tracking-tight max-w-3xl leading-[1.05]">
          Seven services. One trusted crew.
        </h1>
        <p className="mt-5 max-w-2xl text-muted-foreground leading-relaxed">
          Every service is delivered by our own uniformed team, insured up to ₹5L, and priced transparently — no hidden line items.
        </p>
      </section>

      <section className="pb-24 max-w-7xl mx-auto px-6 lg:px-10 space-y-16">
        {SERVICES.map((s, i) => (
          <div
            key={s.key}
            data-testid={`svc-row-${i}`}
            className={`grid gap-10 lg:grid-cols-2 items-center ${
              i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
            }`}
          >
            <div className="aspect-[4/3] rounded-2xl overflow-hidden">
              <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
            </div>
            <div>
              <div className="text-xs px-3 py-1 rounded-full bg-primary/10 text-primary inline-block font-medium">
                {s.priceLabel}
              </div>
              <h2 className="mt-4 font-display text-3xl lg:text-4xl tracking-tight">
                {s.title}
              </h2>
              <p className="mt-4 text-muted-foreground leading-relaxed">{s.blurb}</p>
              <ul className="mt-6 space-y-2 text-sm">
                {[
                  "Free on-site survey (Hyderabad)",
                  "Insured transit up to ₹5,00,000",
                  "Bubble wrap, corner boards, wooden crates",
                  "Doorstep unpacking & reassembly",
                ].map((p) => (
                  <li key={p} className="flex gap-2">
                    <Check className="w-4 h-4 text-primary mt-0.5" /> {p}
                  </li>
                ))}
              </ul>
              <Link to="/quote">
                <Button className="mt-6 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground">
                  Get instant quote <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>
        ))}
      </section>
      <Footer />
      <ChatWidget />
    </div>
  );
}
